import { consoleApiSlice } from "./consoleApiSlice";
import { setCredentials } from "../../authSlice";

export const consoleAuthApiSlice = consoleApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (credentials) => ({
                url: "/api/v1/auth/signin",
                method: "POST",
                body: credentials,
            }),
        }),
        refresh: builder.mutation({
            query: () => ({
                url: '/api/v1/auth/refresh',
                method: 'POST',
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(setCredentials({
                        accessToken: data.access_token,
                        user: data
                    }));
                } catch (err) {
                    console.error('Refresh token failed:', err);
                }
            }
        }),
        forgotPassword: builder.mutation({
            query: ({ email }) => ({
                url: '/api/v1/auth/forgot-password',
                method: 'POST',
                body: { email },
            }),
        }),
        resetPassword: builder.mutation({
            query: ({ token, newPassword }) => ({
                url: '/api/v1/auth/reset-password',
                method: 'POST',
                body: { token, new_password: newPassword },
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: '/api/v1/auth/logout',
                method: 'POST',
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useRefreshMutation,
    useLogoutMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
} = consoleAuthApiSlice;
